import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { ConfirmModel, ConfirmPayload } from '../../models/confirm.model';

// identifier
export const CONFIRM_SLICE_ID = 'confirm';

// default state
const initialState: ConfirmModel = {
  dialogs: {},
  dialogParams: {},
};

//slice
const confirmSlice = createSlice({
  name: CONFIRM_SLICE_ID,
  initialState,
  reducers: {
    showConfirm: (state: ConfirmModel, action: PayloadAction<ConfirmPayload>) => {
      const { payload } = action;
      state.dialogs[payload.id] = true;
      state.dialogParams[payload.id] = payload.param;
    },
    hideConfirm: (state: ConfirmModel, action: PayloadAction<string>) => {
      state.dialogs[action.payload] = false;
      state.dialogParams[action.payload] = undefined;
    },
  },
});

//selectors

export const selectConfirmDialogVisible = (state: RootState, id: string) => {
  if (state.confirm.dialogs[id]) {
    return state.confirm.dialogs[id];
  }
  return false;
};

export const selectConfirmDialogParam = (state: RootState, id: string): any => {
  if (state.confirm.dialogParams[id]) {
    return state.confirm.dialogParams?.[id];
  }
  return undefined;
};

//actions
export const { showConfirm, hideConfirm } = confirmSlice.actions;

//reducer
export default confirmSlice;
